import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {User} from '../../../models/user.model';
import {UserService} from '../../../services/users.service';

@Component({
  providers: [UserService],
  selector: 'app-users',
  templateUrl: './admin.users.component.html'
})
export class AdminUsersComponent implements OnInit {
  public users: User[];

  private _selectedUser: User;

  constructor(private _usersService: UserService, private _elementReference: ElementRef, public router: Router) {
    this._usersService.users$.subscribe((users) => {
      this.users = users;
    });
  }

  public ngOnInit(): void {
    this._usersService.loadAll();
  }

  set selectedUser(value: User) {
    this._selectedUser = value;
    this.detailsUser();
  }

  get selectedUser(): User {
    return this._selectedUser;
  }

  public addUser(): void {
    this.router.navigate(['/users/new']);
  }

  public detailsUser(): void {
    if (this.selectedUser) {
      this.router.navigate(['/users', this.selectedUser._id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/users/admin.users.component.ts